export default __webpack_public_path__ + "static/media/SN2-1.5753e4ed.jpg";